import React, { useState } from "react";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';

const EnvasadoTerminadoSection = ({
  terminadoRecords = [],
  onValidarInspector
}) => {
  const [selectedRecord, setSelectedRecord] = useState(null);

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <div>
          <h2>Inventarios de Mezcal Envasado "Terminado" (Sección IV)</h2>
          <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "13px" }}>
            Registro de lotes de producto terminado generados tras completar el envasado y asignación de hologramas.
          </p>
        </div>
      </div>

      <div className="records-list-wrapper">
        <table className="records-table">
          <thead>
            <tr>
              {/* Identificación */}
              <th>Fecha Mov.</th>
              <th>Bot/Caja</th>
              <th>Marca</th>
              <th>Lote Granel</th>
              <th>Lote Env.</th>
              <th>Categoría</th>
              <th>Clase</th>
              <th>Clase Etiqueta</th>
              <th>Hologramas Asignados</th>

              {/* Cierre */}
              <th>V.Bo. Inspector</th>
              <th>Estado</th>
              <th style={{ textAlign: "center", minWidth: "160px" }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {terminadoRecords.length === 0 ? (
              <tr>
                <td colSpan="12" style={{ textAlign: "center", padding: "30px", color: "var(--text-muted)" }}>
                  No hay registros de producto terminado en este momento.
                </td>
              </tr>
            ) : (
              terminadoRecords.map((rec, i) => {
                const rangos = rec.rangosHologramas || [];
                const tieneHologramas = rangos.length > 0;

                return (
                  <tr key={i}>
                    <td>{rec.fechaMovimiento}</td>
                    <td>{rec.botCaja}</td>
                    <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                    <td>{rec.noLoteGranel}</td>
                    <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.loteEnvasado}</td>
                    <td>{rec.categoria}</td>
                    <td>{rec.clase || rec.claseEtiqueta || "-"}</td>
                    <td>{rec.claseEtiqueta || rec.clase || "-"}</td>

                    <td>
                      {tieneHologramas ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                          {rangos.map((rg, idx) => (
                            <span
                              key={idx}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                                background: "#FAF5FF",
                                border: "1px solid #D8B4FE",
                                color: "#6B21A8",
                                padding: "2px 8px",
                                borderRadius: "4px",
                                fontSize: "11px",
                                fontWeight: 700
                              }}
                            >
                              <ConfirmationNumberIcon style={{ fontSize: 13 }} />
                              {rg.rangoHologramas || `${rg.prefijo || 'A'}${rg.rango1} - ${rg.prefijo || 'A'}${rg.rango2}`}
                              {rg.cantidad ? ` (${rg.cantidad} hol.)` : ""}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span style={{ color: "var(--text-muted)", fontSize: "11px" }}>Sin folios</span>
                      )}
                    </td>

                    <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                    <td>
                      <span className={`badge-status ${rec.status}`}>
                        {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                      </span>
                    </td>

                    <td>
                      <div style={{ display: "flex", gap: "6px", justifyContent: "center", alignItems: "center" }}>
                        {rec.status === "revision" && onValidarInspector && (
                          <button
                            onClick={() => onValidarInspector(rec)}
                            style={{
                              background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                              border: "none",
                              color: "#fff",
                              borderRadius: "6px",
                              padding: "6px 12px",
                              fontSize: "11px",
                              fontWeight: 700,
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              boxShadow: "0 2px 4px rgba(5, 150, 105, 0.2)"
                            }}
                            title="Validar por Inspector y pasar hologramas al inventario"
                          >
                            <CheckCircleIcon style={{ fontSize: 14 }} />
                            <span>Validar Inspector</span>
                          </button>
                        )}

                        {rec.status === "aprobado" && (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#059669",
                              fontSize: "11px",
                              fontWeight: 700
                            }}
                          >
                            <CheckCircleIcon style={{ fontSize: 14 }} />
                            <span>V.Bo. Validado</span>
                          </span>
                        )}

                        <button
                          onClick={() => setSelectedRecord(rec)}
                          style={{
                            background: "#F1F5F9",
                            border: "1px solid #CBD5E1",
                            color: "#475569",
                            borderRadius: "6px",
                            padding: "6px 8px",
                            fontSize: "11px",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center"
                          }}
                          title="Ver detalle del lote"
                        >
                          <VisibilityIcon style={{ fontSize: 14 }} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL DETALLE DE LOTE TERMINADO */}
      {selectedRecord && (
        <div className="custom-modal-overlay" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div
            className="custom-modal-content animate-scaleUp"
            style={{ maxWidth: "600px", width: "95%", maxHeight: "90vh", overflowY: "auto", borderRadius: "12px", background: "#fff", padding: "24px" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E2E8F0", paddingBottom: "12px", marginBottom: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{ background: "rgba(107, 33, 168, 0.1)", color: "#6B21A8", padding: "8px", borderRadius: "8px" }}>
                  <WorkspacePremiumIcon />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700 }}>Detalle de Lote Terminado</h3>
                  <p style={{ margin: 0, fontSize: "12px", color: "var(--text-muted)" }}>Lote {selectedRecord.loteEnvasado} - {selectedRecord.marca}</p>
                </div>
              </div>
              <button
                onClick={() => setSelectedRecord(null)}
                style={{ background: "transparent", border: "none", cursor: "pointer", color: "#64748B" }}
              >
                <CloseIcon />
              </button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "13px" }}>
              <div><strong>Fecha de Movimiento:</strong> {selectedRecord.fechaMovimiento}</div>
              <div><strong>Marca:</strong> {selectedRecord.marca}</div>
              <div><strong>Lote a Granel:</strong> {selectedRecord.noLoteGranel}</div>
              <div><strong>Lote Envasado:</strong> {selectedRecord.loteEnvasado}</div>
              <div><strong>Categoría:</strong> {selectedRecord.categoria}</div>
              <div><strong>Clase:</strong> {selectedRecord.clase || selectedRecord.claseEtiqueta || "-"}</div>
              <div><strong>Clase Etiqueta:</strong> {selectedRecord.claseEtiqueta || selectedRecord.clase || "-"}</div>
              <div><strong>Tipo de Maguey:</strong> {selectedRecord.tipoMagueyEtiqueta || selectedRecord.tipoMaguey || "Espadín"}</div>
              <div><strong>Capacidad:</strong> {selectedRecord.capacidad || "750 ml"}</div>
              <div><strong>% Alc. Vol.:</strong> {selectedRecord.pctAlcEtiqueta || selectedRecord.pctAlc || "-"}</div>
              <div><strong>No. Informe Aprobación:</strong> {selectedRecord.noInformeAprobacion || "-"}</div>
              <div><strong>Estatus:</strong> <span className={`badge-status ${selectedRecord.status}`}>{selectedRecord.status}</span></div>
              <div><strong>Inspector:</strong> {selectedRecord.inspector}</div>
            </div>

            <div style={{ marginTop: "16px", padding: "12px", background: "#FAF5FF", borderRadius: "8px", border: "1px solid #E9D5FF" }}>
              <h4 style={{ margin: "0 0 8px 0", color: "#6B21A8", fontSize: "13px", display: "flex", alignItems: "center", gap: "6px" }}>
                <ConfirmationNumberIcon style={{ fontSize: 16 }} />
                Rangos de Hologramas Asignados
              </h4>
              {(selectedRecord.rangosHologramas || []).length === 0 ? (
                <p style={{ margin: 0, fontSize: "12px", color: "#6B21A8" }}>No se registraron folios específicos.</p>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  {selectedRecord.rangosHologramas.map((r, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", background: "#fff", padding: "6px 10px", borderRadius: "6px", border: "1px solid #D8B4FE" }}>
                      <span><strong>Rango:</strong> {r.rangoHologramas || `${r.prefijo || 'A'}${r.rango1} - ${r.prefijo || 'A'}${r.rango2}`}</span>
                      <span><strong>Cantidad:</strong> {r.cantidad || r.cantidadInicial || "0"} folios</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => setSelectedRecord(null)}
                className="btn-secondary-custom"
                style={{ padding: "8px 16px" }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnvasadoTerminadoSection;
